// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomUser = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '19',
      viewBox: '0 0 16 19',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        id: 'User',
      },
      /*#__PURE__*/ React.createElement('circle', {
        id: 'Ellipse 33',
        cx: '4',
        cy: '4',
        r: '4',
        transform: 'matrix(-1 0 0 1 12 1)',
        fill: 'currentColor',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      }),
      /*#__PURE__*/ React.createElement('path', {
        id: 'Rectangle 2',
        d: 'M1 14.9347C1 14.0743 1.54085 13.3068 2.35109 13.0175C6.00404 11.7128 9.99596 11.7128 13.6489 13.0175C14.4591 13.3068 15 14.0743 15 14.9347V16.2502C15 17.4376 13.9483 18.3498 12.7728 18.1818L11.8184 18.0455C9.28565 17.6837 6.71435 17.6837 4.18162 18.0455L3.22721 18.1818C2.0517 18.3498 1 17.4376 1 16.2502V14.9347Z',
        fill: 'currentColor',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      }),
    ),
  );

export { IconCustomUser };
